export default {
  api: {
    list: {
      method: "get",
      url: "/balance/log/list"
    }
  }
};
